import Cookies from "js-cookie";

/**
 * Class to handle the cookie management needed for the chat bot. Currently
 * this is assumed to only manage against the .huntington.com domain.
 */
export default class KoreChatCookieManager {

    constructor() {
        this.domain = '.huntington.com';
        this.path = '/';
    }

    /**
     * Deletes the cookie with the provided name.
     * @param {String} cookieName The name of the cookie to be deleted.
     */
    deleteCookie(cookieName) {
        Cookies.remove(cookieName, {domain: this.domain, path: this.path});
    }

    /**
     * Gets the cookie with the provided name and returns it's value. If no value is present
     * on the cookie, it returns an empty string.
     * @param {String} cookieName The name of the cookie to have it's value read.
     * @returns Either the cookie value or an empty string.
     */
    readcookie(cookieName) {
        const cookieValue = Cookies.get(cookieName);
        return cookieValue || '';
    }

    /**
     * Creates the cookie with the appropriate name and value only if the cookie already
     * does not exist.
     * @param {String} cookieName The name of the cookie to be created.
     * @param {String} cookieValue The value of the cookie to be created.
     * @param {Number} expirationTime The optional expiration time of the cookie to be created.
     */
    createCookie(cookieName, cookieValue, expirationTime = undefined) {
        if (!Cookies.get(cookieName)) {
            expirationTime ?
            Cookies.set(cookieName, cookieValue, {path: this.path, domain: this.domain, secure: true, expires: expirationTime }) :
            Cookies.set(cookieName, cookieValue, {path: this.path, domain: this.domain, secure: true});
        }
    }

    /**
     * Updates the cookie with the appropriate name and value only if the cookie already
     * exists.
     * @param {String} cookieName The name of the cookie to be created.
     * @param {String} cookieValue The value of the cookie to be created.
     * @param {Number} expirationTime The optional expiration time of the cookie to be created.
     */
    updateCookie(cookieName, cookieValue, expirationTime = undefined) {
        if (Cookies.get(cookieName)) {
            expirationTime ?
            Cookies.set(cookieName, cookieValue, {path: this.path, domain: this.domain, secure: true, expires: expirationTime }) :
            Cookies.set(cookieName, cookieValue, {path: this.path, domain: this.domain, secure: true});
        }
    }
}